import styled, { css } from 'styled-components';
import Alert from '../components/Alert';
import Button from '../components/Common/Button';
import VariantSelect from './components/VariantSelect';

const DEFAULT_FONT_SIZE = '16px';

export const StyledExceededAlert = styled(Alert)`${(props) => {
  const textAlign = props.needTextLeft ? 'left' : 'center';
  return css`
    text-align: ${textAlign};
  `;
}}`;

export const StyledNextButton = styled(Button)`${(props) => {
  const fs = props.fontSize || DEFAULT_FONT_SIZE;
  return css`
    && {
      font-size: ${fs};
      background-color: ${props.bc};
    }
  `;
}}`;

export const StyledVariantSelect = styled(VariantSelect)`
  width: 96%;
  height: auto;
  box-sizing: content-box;
  text-align: left;
  margin-top: 20px;
  & > h4 {
    margin-top: 0;
    margin-bottom: 0;
    font-weight: 400;
  }
  & > h4 + div {
    margin-top: 10px;
  }
`;

export const StyledWaitlistButton = styled(Button)`${(props) => {
  const fs = props.fontSize || DEFAULT_FONT_SIZE;
  return css`
    && {
      font-size: ${fs};
      margin-top: 20px;
    }`;
}}`;

export const StyledModalContentDiv = styled.div`${(props) => {
  const style = props.style || {};

  return css`
    padding: ${style.container?.padding}px;  
      
    button {
      border-radius: ${style.body?.buttonsBorderRadius}px !important;  
    }
  `;
}}`;
